export default {
  id: 'CreateTeacherModal',
  code: 'CN',
  text: {
    'Create Teacher': '新增老师',
    'Edit Teacher': '编辑老师',
    'Teacher Name': '老师姓名',
    'Gender': '性别',
    'Email': '邮件地址',
    'Phone Number': '手机号',
    "Enter a phone number to invite the teacher to download the ClassTopBase mobile App. The teacher could then change the attendance, as well as sending and receiving announcements and schedules. You could change teacher's permissions inside the permissions settings": '填写手机号可以邀请老师下载手机端APP, 老师可以用APP给自己和学生签到, 接收通知和课表, 您可以在权限设置里安排老师的权限',
    'Phone number already existed': '此手机号已存在',
    'Phone number already existed in Archived Teacher': '添加的老师已经在历史老师里面，如有需要请恢复',
    'Teacher Photo': '老师头像'
  }
}



// WEBPACK FOOTER //
// ./src/template/Modals/CreateTeacher/locale.js